var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureThumbsupOff = function SvgGeneralFeatureThumbsupOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M5.1 21.978h-.637A2.264 2.264 0 0 1 2.2 19.714v-9.032h2.9zM10.858 1.5a2.26 2.26 0 0 1 2.26 2.225l.004 3.634a2.265 2.265 0 0 0 2.265 2.264h5.09c.94 0 1.707.769 1.707 1.708 0 .893-.694 1.631-1.57 1.702a1.704 1.704 0 0 1-.757 3.154c.49.297.819.838.819 1.452 0 .894-.696 1.632-1.572 1.702a1.7 1.7 0 0 1 .816 1.451c0 .94-.768 1.708-1.706 1.708h-4.576q-.113 0-.222-.014l-.876-.021-1.264-.045-.802-.036-1.487-.084-1.868-.134-2.017-.188-.014-11.297.626-.88.34-.457c.218-.286.435-.545.714-.85l.476-.499.289-.292c.854-.854 1.024-1.843 1.054-3.256l.006-.683c0-1.177.898-2.144 2.046-2.254z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureThumbsupOff;